export const getNavarraData = () => ({
  name: "Navarra",
  country: "Espagne",
  description: "Navarra est une région viticole du nord de l'Espagne, connue pour sa diversité de vins et ses traditions viticoles anciennes, alliant tradition et modernité.",
  type: "region",
  subregions: [
    { name: "Tierra Estella", area: "6,000 ha", percentage: "33%", description: "Vins rouges et rosés traditionnels" },
    { name: "Valdizarbe", area: "3,000 ha", percentage: "17%", description: "Vins de terroir" },
    { name: "Baja Montaña", area: "2,500 ha", percentage: "14%", description: "Vins de montagne" },
    { name: "Ribera Alta", area: "4,000 ha", percentage: "22%", description: "Vins modernes" },
    { name: "Ribera Baja", area: "2,500 ha", percentage: "14%", description: "Vins puissants" }
  ],
  mapAreas: [
    { region: "Tierra Estella", x: 46, y: 30, color: "#4B164C", size: 5 },
    { region: "Valdizarbe", x: 48, y: 32, color: "#6d2c7a", size: 4 },
    { region: "Baja Montaña", x: 50, y: 28, color: "#8a4a8a", size: 3 },
    { region: "Ribera Alta", x: 47, y: 35, color: "#a768a6", size: 4 },
    { region: "Ribera Baja", x: 49, y: 38, color: "#c486c4", size: 3 }
  ],
  statistics: {
    totalArea: "18,000 ha",
    production: "70 million litres",
    wineries: "150+ bodegas",
    appellations: "5 sous-régions",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat continental avec influences atlantiques et méditerranéennes",
    soil: "Sols calcaires, argilo-calcaires et galets roulés",
    viticulture: "Diversité de cépages, techniques traditionnelles et modernes"
  },
  wineStyles: {
    red: "Vins rouges variés, du fruité au structuré, avec une bonne acidité",
    white: "Vins blancs secs et aromatiques, principalement de Chardonnay et Viura",
    rosé: "Rosés traditionnels et modernes, très appréciés"
  },
  history: "La viticulture à Navarra remonte aux Romains. Au Moyen Âge, les pèlerins de Saint-Jacques-de-Compostelle ont contribué au développement viticole. La région a su moderniser ses techniques tout en préservant ses traditions.",
  foodPairing: "Viandes rouges, agneau, fromages de brebis, cuisine basque et navarraise"
}); 